<template>
    <div>
        <el-table
                :data="tableData"
                style="width: 100%;margin-bottom: 20px;"
                :row-key="rowKey"
                border
                highlight-current-row
                :tree-props="{children: children, hasChildren: hasChildren}">
            <el-table-column
                    :prop="tableCol.prop"
                    :label="tableCol.label"
                    v-for="(tableCol,index) in tableSet.tableColumn"
                    :key="index"
                    :formatter="tableCol.formatter"
            >
                <template slot-scope="scope">
                    <div v-if="tableCol.type=='Dialog'">
                        <el-button type="text" @click="clickDialog(scope.row[tableCol.prop])" slot="reference">{{scope.row[tableCol.prop]}}</el-button>
                    </div>
                    <div v-else-if="tableCol.type=='tag'">
                      <div v-for="(item,index) in tableCol.options" :key="index">
                        <el-tag v-if="item.value===scope.row[tableCol.prop]" :type="item.color">{{item.label}}</el-tag>
                      </div>            
                    </div>
                    <span v-else>{{scope.row[tableCol.prop]}}</span>
                </template>
            </el-table-column>
            <template v-if="tableSet.tableColBtn">
            <el-table-column
                    label="操作"
                    align="center"
                    width="280"

            >
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                                v-for="(btn,index) in tableSet.tableColBtn" :key="index"
                                v-if="btn.show"
                                :size="btn.size"
                                :type="btn.type"
                                :plain="btn.planin"
                                :round="btn.round"
                                :circle="btn.circle"
                                :loading="btn.loading"
                                :disabled="btn.disabled"
                                :icon="btn.icon"
                                :title="btn.title"
                                @click="btn.click(scope.$index, scope.row)"
                        >
                            <span v-if="btn.name!=''">{{btn.name}}</span>
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
            </template>
        </el-table>
        <!-- <div class="pagination">
            <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    @current-change="goCurrentChange"
                    :total="pageCount"
            >
            </el-pagination>
        </div> -->
    </div>
</template>

<script>
  export default {
    name: 'DynamicTreeTable',
    data(){
      return {

      }
    },
    props: {
      rowKey:{
        type:String
      },
      children:{
        type:String
      },
      hasChildren:{
        type:String
      },
      tableSet: {
        type: Object,
        default: () => {}
      },
      tableData: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      // 单元格样式
      cellStyle (row, column, rowIndex, columnIndex) {
        return 'padding:6px 0px'
      },
      // 行双击
      rowClick (row) {
        this.$emit('rowClick', row)
      },
      // 跳转页数
      goCurrentChange (val) {
        // alert("跳转:" + val);
        this.$emit('goPageIndex', val)
      },
      // 显示对话框
      clickDialog (val) {
        // this.showDialog = true
        // this.dialogTitle = val
        this.$emit('clickDialog', val)
      }
    }
  }
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Tables/DynamicTreeTable.vue"
}
</vue-filename-injector>
